/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const isClientPassword = /* GraphQL */ `
  query IsClientPassword($id: ID!, $clientPassword: String!) {
    isClientPassword(id: $id, clientPassword: $clientPassword) {
      id
      expiryDate
      clientPassword
      description
      createdAt
      updatedAt
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        eventLocationLookup {
          nextToken
        }
        updatedAt
        event {
          nextToken
        }
        eventClientAccess {
          nextToken
        }
      }
    }
  }
`;
export const getEventLocationLookup = /* GraphQL */ `
  query GetEventLocationLookup($id: ID!) {
    getEventLocationLookup(id: $id) {
      id
      addressLine1
      addressLine2
      town
      postcode
      createdAt
      isDeleted
      updatedAt
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        eventLocationLookup {
          nextToken
        }
        updatedAt
        event {
          nextToken
        }
        eventClientAccess {
          nextToken
        }
      }
    }
  }
`;
export const listEventLocationLookups = /* GraphQL */ `
  query ListEventLocationLookups(
    $filter: ModelEventLocationLookupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventLocationLookups(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        addressLine1
        addressLine2
        town
        postcode
        createdAt
        isDeleted
        updatedAt
        eventCompany {
          id
          name
          createdAt
          logo
          logoFileName
          email
          isDeleted
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const getEventBooking = /* GraphQL */ `
  query GetEventBooking($id: ID!) {
    getEventBooking(id: $id) {
      id
      firstname
      lastname
      email
      mobile
      dob
      customData
      createdAt
      startTime
      twentyFourHourReminder
      fortyEightHourReminder
      attendance
      marketing
      searchField
      isDeleted
      updatedAt
      eventSlot {
        id
        time
        length
        type
        booked
        isDeleted
        eventBooking {
          nextToken
        }
        createdAt
        updatedAt
        eventSlotGroup {
          id
          room
          date
          capacity
          createdAt
          active
          isDeleted
          assignedTo
          updatedAt
        }
      }
    }
  }
`;
export const listEventBookings = /* GraphQL */ `
  query ListEventBookings(
    $filter: ModelEventBookingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventBookings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstname
        lastname
        email
        mobile
        dob
        customData
        createdAt
        startTime
        twentyFourHourReminder
        fortyEightHourReminder
        attendance
        marketing
        searchField
        isDeleted
        updatedAt
        eventSlot {
          id
          time
          length
          type
          booked
          isDeleted
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const bookingBySearchField = /* GraphQL */ `
  query BookingBySearchField(
    $searchField: String
    $sortDirection: ModelSortDirection
    $filter: ModelEventBookingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bookingBySearchField(
      searchField: $searchField
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstname
        lastname
        email
        mobile
        dob
        customData
        createdAt
        startTime
        twentyFourHourReminder
        fortyEightHourReminder
        attendance
        marketing
        searchField
        isDeleted
        updatedAt
        eventSlot {
          id
          time
          length
          type
          booked
          isDeleted
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const getEventCompany = /* GraphQL */ `
  query GetEventCompany($id: ID!) {
    getEventCompany(id: $id) {
      id
      name
      createdAt
      logo
      logoFileName
      email
      isDeleted
      eventLocationLookup {
        items {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          isDeleted
          updatedAt
        }
        nextToken
      }
      updatedAt
      event {
        items {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          createdAt
          isDeleted
          updatedAt
        }
        nextToken
      }
      eventClientAccess {
        items {
          id
          expiryDate
          clientPassword
          description
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const listEventCompanys = /* GraphQL */ `
  query ListEventCompanys(
    $filter: ModelEventCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventCompanys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        eventLocationLookup {
          nextToken
        }
        updatedAt
        event {
          nextToken
        }
        eventClientAccess {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getEvent = /* GraphQL */ `
  query GetEvent($id: ID!) {
    getEvent(id: $id) {
      id
      name
      code
      type
      requireDob
      iCalendar
      attendance
      status
      message
      description
      commsTemplate
      bloodDropStart
      bloodDropEnd
      urinePotLocation
      preQuestionTemplate
      clientPassword
      commsLink
      clientAccess
      createdAt
      isDeleted
      updatedAt
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        eventLocationLookup {
          nextToken
        }
        updatedAt
        event {
          nextToken
        }
        eventClientAccess {
          nextToken
        }
      }
      eventLocation {
        items {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          eventLocationLookupId
          isDeleted
          updatedAt
        }
        nextToken
      }
      eventCollectUserData {
        items {
          id
          label
          questionType
          validation
          fieldType
          createdAt
          success
          error
          hint
          isDeleted
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const listEvents = /* GraphQL */ `
  query ListEvents(
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        code
        type
        requireDob
        iCalendar
        attendance
        status
        message
        description
        commsTemplate
        bloodDropStart
        bloodDropEnd
        urinePotLocation
        preQuestionTemplate
        clientPassword
        commsLink
        clientAccess
        createdAt
        isDeleted
        updatedAt
        eventCompany {
          id
          name
          createdAt
          logo
          logoFileName
          email
          isDeleted
          updatedAt
        }
        eventLocation {
          nextToken
        }
        eventCollectUserData {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const eventByCode = /* GraphQL */ `
  query EventByCode(
    $code: String
    $sortDirection: ModelSortDirection
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    eventByCode(
      code: $code
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        code
        type
        requireDob
        iCalendar
        attendance
        status
        message
        description
        commsTemplate
        bloodDropStart
        bloodDropEnd
        urinePotLocation
        preQuestionTemplate
        clientPassword
        commsLink
        clientAccess
        createdAt
        isDeleted
        updatedAt
        eventCompany {
          id
          name
          createdAt
          logo
          logoFileName
          email
          isDeleted
          updatedAt
        }
        eventLocation {
          nextToken
        }
        eventCollectUserData {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getEventLocation = /* GraphQL */ `
  query GetEventLocation($id: ID!) {
    getEventLocation(id: $id) {
      id
      addressLine1
      addressLine2
      town
      postcode
      createdAt
      eventLocationLookupId
      isDeleted
      updatedAt
      event {
        id
        name
        code
        type
        requireDob
        iCalendar
        attendance
        status
        message
        description
        commsTemplate
        bloodDropStart
        bloodDropEnd
        urinePotLocation
        preQuestionTemplate
        clientPassword
        commsLink
        clientAccess
        createdAt
        isDeleted
        updatedAt
        eventCompany {
          id
          name
          createdAt
          logo
          logoFileName
          email
          isDeleted
          updatedAt
        }
        eventLocation {
          nextToken
        }
        eventCollectUserData {
          nextToken
        }
      }
      eventSlotGroup {
        items {
          id
          room
          date
          capacity
          createdAt
          active
          isDeleted
          assignedTo
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const listEventLocations = /* GraphQL */ `
  query ListEventLocations(
    $filter: ModelEventLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventLocations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        addressLine1
        addressLine2
        town
        postcode
        createdAt
        eventLocationLookupId
        isDeleted
        updatedAt
        event {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          createdAt
          isDeleted
          updatedAt
        }
        eventSlotGroup {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getEventCollectUserData = /* GraphQL */ `
  query GetEventCollectUserData($id: ID!) {
    getEventCollectUserData(id: $id) {
      id
      label
      questionType
      validation
      fieldType
      createdAt
      success
      error
      hint
      isDeleted
      updatedAt
      event {
        id
        name
        code
        type
        requireDob
        iCalendar
        attendance
        status
        message
        description
        commsTemplate
        bloodDropStart
        bloodDropEnd
        urinePotLocation
        preQuestionTemplate
        clientPassword
        commsLink
        clientAccess
        createdAt
        isDeleted
        updatedAt
        eventCompany {
          id
          name
          createdAt
          logo
          logoFileName
          email
          isDeleted
          updatedAt
        }
        eventLocation {
          nextToken
        }
        eventCollectUserData {
          nextToken
        }
      }
      eventCollectUserDataOptions {
        items {
          id
          options
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const listEventCollectUserDatas = /* GraphQL */ `
  query ListEventCollectUserDatas(
    $filter: ModelEventCollectUserDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventCollectUserDatas(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        label
        questionType
        validation
        fieldType
        createdAt
        success
        error
        hint
        isDeleted
        updatedAt
        event {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          createdAt
          isDeleted
          updatedAt
        }
        eventCollectUserDataOptions {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getEventCollectUserDataOptions = /* GraphQL */ `
  query GetEventCollectUserDataOptions($id: ID!) {
    getEventCollectUserDataOptions(id: $id) {
      id
      options
      isDeleted
      createdAt
      updatedAt
      eventCollectUserData {
        id
        label
        questionType
        validation
        fieldType
        createdAt
        success
        error
        hint
        isDeleted
        updatedAt
        event {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          createdAt
          isDeleted
          updatedAt
        }
        eventCollectUserDataOptions {
          nextToken
        }
      }
    }
  }
`;
export const listEventCollectUserDataOptionss = /* GraphQL */ `
  query ListEventCollectUserDataOptionss(
    $filter: ModelEventCollectUserDataOptionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventCollectUserDataOptionss(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        options
        isDeleted
        createdAt
        updatedAt
        eventCollectUserData {
          id
          label
          questionType
          validation
          fieldType
          createdAt
          success
          error
          hint
          isDeleted
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const getEventSlotGroup = /* GraphQL */ `
  query GetEventSlotGroup($id: ID!) {
    getEventSlotGroup(id: $id) {
      id
      room
      date
      capacity
      createdAt
      active
      isDeleted
      assignedTo
      updatedAt
      eventLocation {
        id
        addressLine1
        addressLine2
        town
        postcode
        createdAt
        eventLocationLookupId
        isDeleted
        updatedAt
        event {
          id
          name
          code
          type
          requireDob
          iCalendar
          attendance
          status
          message
          description
          commsTemplate
          bloodDropStart
          bloodDropEnd
          urinePotLocation
          preQuestionTemplate
          clientPassword
          commsLink
          clientAccess
          createdAt
          isDeleted
          updatedAt
        }
        eventSlotGroup {
          nextToken
        }
      }
      eventSlot {
        items {
          id
          time
          length
          type
          booked
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const listEventSlotGroups = /* GraphQL */ `
  query ListEventSlotGroups(
    $filter: ModelEventSlotGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventSlotGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        room
        date
        capacity
        createdAt
        active
        isDeleted
        assignedTo
        updatedAt
        eventLocation {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          eventLocationLookupId
          isDeleted
          updatedAt
        }
        eventSlot {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getEventSlot = /* GraphQL */ `
  query GetEventSlot($id: ID!) {
    getEventSlot(id: $id) {
      id
      time
      length
      type
      booked
      isDeleted
      eventBooking {
        items {
          id
          firstname
          lastname
          email
          mobile
          dob
          customData
          createdAt
          startTime
          twentyFourHourReminder
          fortyEightHourReminder
          attendance
          marketing
          searchField
          isDeleted
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
      eventSlotGroup {
        id
        room
        date
        capacity
        createdAt
        active
        isDeleted
        assignedTo
        updatedAt
        eventLocation {
          id
          addressLine1
          addressLine2
          town
          postcode
          createdAt
          eventLocationLookupId
          isDeleted
          updatedAt
        }
        eventSlot {
          nextToken
        }
      }
    }
  }
`;
export const listEventSlots = /* GraphQL */ `
  query ListEventSlots(
    $filter: ModelEventSlotFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventSlots(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        time
        length
        type
        booked
        isDeleted
        eventBooking {
          nextToken
        }
        createdAt
        updatedAt
        eventSlotGroup {
          id
          room
          date
          capacity
          createdAt
          active
          isDeleted
          assignedTo
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const getEventCommsTemplate = /* GraphQL */ `
  query GetEventCommsTemplate($id: ID!) {
    getEventCommsTemplate(id: $id) {
      id
      name
      emailSubject
      reminderEmailSubject
      emailTemplate
      reminderEmailTemplate
      smsReminderTemplate
      smsTemplate
      isDeleted
      createdAt
      updatedAt
      eventCommsTemplateAttachments {
        items {
          id
          attachment
          key
          name
          isDeleted
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const listEventCommsTemplates = /* GraphQL */ `
  query ListEventCommsTemplates(
    $filter: ModelEventCommsTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventCommsTemplates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        emailSubject
        reminderEmailSubject
        emailTemplate
        reminderEmailTemplate
        smsReminderTemplate
        smsTemplate
        isDeleted
        createdAt
        updatedAt
        eventCommsTemplateAttachments {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getEventCommsTemplateAttachments = /* GraphQL */ `
  query GetEventCommsTemplateAttachments($id: ID!) {
    getEventCommsTemplateAttachments(id: $id) {
      id
      attachment
      key
      name
      isDeleted
      createdAt
      updatedAt
      EventCommsTemplate {
        id
        name
        emailSubject
        reminderEmailSubject
        emailTemplate
        reminderEmailTemplate
        smsReminderTemplate
        smsTemplate
        isDeleted
        createdAt
        updatedAt
        eventCommsTemplateAttachments {
          nextToken
        }
      }
    }
  }
`;
export const listEventCommsTemplateAttachmentss = /* GraphQL */ `
  query ListEventCommsTemplateAttachmentss(
    $filter: ModelEventCommsTemplateAttachmentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventCommsTemplateAttachmentss(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        attachment
        key
        name
        isDeleted
        createdAt
        updatedAt
        EventCommsTemplate {
          id
          name
          emailSubject
          reminderEmailSubject
          emailTemplate
          reminderEmailTemplate
          smsReminderTemplate
          smsTemplate
          isDeleted
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const getEventClientAccess = /* GraphQL */ `
  query GetEventClientAccess($id: ID!) {
    getEventClientAccess(id: $id) {
      id
      expiryDate
      clientPassword
      description
      createdAt
      updatedAt
      eventCompany {
        id
        name
        createdAt
        logo
        logoFileName
        email
        isDeleted
        eventLocationLookup {
          nextToken
        }
        updatedAt
        event {
          nextToken
        }
        eventClientAccess {
          nextToken
        }
      }
    }
  }
`;
export const listEventClientAccesss = /* GraphQL */ `
  query ListEventClientAccesss(
    $filter: ModelEventClientAccessFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventClientAccesss(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        expiryDate
        clientPassword
        description
        createdAt
        updatedAt
        eventCompany {
          id
          name
          createdAt
          logo
          logoFileName
          email
          isDeleted
          updatedAt
        }
      }
      nextToken
    }
  }
`;
